// @flow

import React from "react";
import { localize } from "redux-i18n";

import { Button, Modal, ModalBody, ModalHeader, ModalFooter } from "@components";
import type { SpecialContact } from "@modules/service/reducer/special-contacts/types";

type Props = {
  specialContact: ?SpecialContact,
  onCancel: Function,
  onSubmit: Function,
  ...PropsFromLocalize,
};

export const SpecialContactsRemoveModal = (props: Props) => (
  <Modal className="modal-small">
    <ModalHeader toggle={props.onCancel} className="d-flex justify-content-between">
      {props.t("REMOVE_SPECIAL_CONTACT_MODAL_TITLE")}
    </ModalHeader>
    <ModalBody className="d-flex justify-content-center align-items-center">
      <p>
        {props.t("REMOVE_SPECIAL_CONTACT_CONFIRMATION", {
          specialContact: ((props.specialContact || {}).employee || {}).name || "",
        })}
      </p>
    </ModalBody>
    <ModalFooter className="d-flex justify-content-end">
      <Button color="secondary" onClick={props.onCancel}>
        {props.t("CANCEL")}
      </Button>
      <Button materialIcon="delete_forever" onClick={props.onSubmit}>
        {props.t("DELETE")}
      </Button>
    </ModalFooter>
  </Modal>
);

export default localize()(SpecialContactsRemoveModal);
